import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import axios from 'axios';
import dayjs from 'dayjs';
import {
    BootstrapVue,
    BIcon,
    BIconstack,
    BIconCaretRightFill,
    BIconChatDotsFill,
    BIconThreeDots,
    BIconX,
    BIconPlus,
    BIconPencil,
    BIconTrash,
    BIconChevronDoubleLeft,
    BIconChevronDoubleRight,
    BIconChevronDoubleDown,
    BIconExclamationCircle,
    BIconEye,
    BIconFileEarmarkExcel,
    BIconCheckSquare,
    BIconXSquare,
    BIconArrowCounterclockwise,
    BIconPlusSquare,
    BIconGearFill,
    BIconInfoCircle,
    BIconFullscreen,
    BIconChevronLeft,
    BIconArrowDownUp,
    BIconFolder,
    BIconArrowRepeat,
    BIconLockFill,
    BIconFileEarmarkArrowUp,
    BIconCardList,
    BIconFileEarmarkBarGraph
} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

//Vue.config.devtools = true;
Vue.use(BootstrapVue);
Vue.component('BIcon', BIcon);
Vue.component('BIconCaretRightFill', BIconCaretRightFill);
Vue.component('BIconChatDotsFill', BIconChatDotsFill);
Vue.component('BIconThreeDots', BIconThreeDots);
Vue.component('BIconX', BIconX);
Vue.component('BIconPlus', BIconPlus);
Vue.component('BIconPlusSquare', BIconPlusSquare);
Vue.component('BIconPencil', BIconPencil);
Vue.component('BIconTrash', BIconTrash);
Vue.component('BIconChevronDoubleLeft', BIconChevronDoubleLeft);
Vue.component('BIconChevronDoubleRight', BIconChevronDoubleRight);
Vue.component('BIconChevronDoubleDown', BIconChevronDoubleDown);
Vue.component('BIconExclamationCircle', BIconExclamationCircle);
Vue.component('BIconEye', BIconEye);
Vue.component('BIconFileEarmarkExcel', BIconFileEarmarkExcel);
Vue.component('BIconCheckSquare', BIconCheckSquare);
Vue.component('BIconXSquare', BIconXSquare);
Vue.component('BIconArrowCounterclockwise', BIconArrowCounterclockwise);
Vue.component('BIconGearFill', BIconGearFill);
Vue.component('BIconInfoCircle', BIconInfoCircle);
Vue.component('BIconFullscreen', BIconFullscreen);
Vue.component('BIconChevronLeft', BIconChevronLeft);
Vue.component('BIconArrowDownUp', BIconArrowDownUp);
Vue.component('BIconFolder', BIconFolder);
Vue.component('BIconArrowRepeat', BIconArrowRepeat);
Vue.component('BIconLockFill', BIconLockFill);
Vue.component('BIconstack', BIconstack);
Vue.component('BIconFileEarmarkArrowUp', BIconFileEarmarkArrowUp);
Vue.component('BIconCardList', BIconCardList);
Vue.component('BIconFileEarmarkBarGraph', BIconFileEarmarkBarGraph);

Vue.component('treeselect', Treeselect);

Vue.config.productionTip = false;

Vue.filter('datetimelong', function (value) {
    if (!value) return '';
    if (!dayjs(value).isValid()) return value;
    return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
});

Vue.mixin({
    methods: {
        _consoleLog(value) {
            // eslint-disable-next-line no-console
            console.log(value);
        },
        _execCopy() {
            document.execCommand('copy');
        },
        _alphanumeric: function (value) {
            if (!value) return '';
            return value.trim().replace(/[^a-zA-Z0-9]/gi, '');
        },
        _alphanumericWithUnderscore: function (value) {
            if (!value) return '';
            return value.trim().replace(/[^a-zA-Z0-9_]/gi, '');
        },
        _alphanumericWithDash: function (value) {
            if (!value) return '';
            return value.trim().replace(/[^a-zA-Z0-9-]/gi, '');
        },
        _sanitize: function (value) {
            if (!value) return '';
            return value
                .trim()
                .replace(/[<>\\]/g, '')
                .replace(/\s\s+/g, ' ');
        },
        _removeSpaces: function (value) {
            if (!value) return '';
            return value.trim().replace(/\s+/g, '');
        },
        _downloadFile(url, formData, callback) {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.responseType = 'arraybuffer';
            xhr.onerror = function () {
                //handle error here
            };
            xhr.onload = function () {
                if (this.status !== 200) {
                    //handle error
                }

                if (this.status === 200) {
                    let filename = '';
                    let disposition = xhr.getResponseHeader('Content-Disposition');
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        let matches = filenameRegex.exec(disposition);
                        if (matches !== null && matches[1])
                            filename = matches[1].replace(/['"]/g, '');
                    }
                    let type = xhr.getResponseHeader('Content-Type');

                    let blob = new Blob([this.response], {type: type});
                    if (typeof window.navigator.msSaveBlob !== 'undefined') {
                        // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created.
                        // These URLs will no longer resolve as the data backing the URL has been freed."
                        window.navigator.msSaveBlob(blob, filename);
                    } else {
                        let URL = window.URL || window.webkitURL;
                        let downloadUrl = URL.createObjectURL(blob);

                        if (filename) {
                            // use HTML5 a[download] attribute to specify filename
                            var a = document.createElement('a');
                            // safari doesn't support this yet
                            if (typeof a.download === 'undefined') {
                                window.location = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename;
                                document.body.appendChild(a);
                                a.click();
                            }
                        } else {
                            window.location = downloadUrl;
                        }

                        setTimeout(function () {
                            URL.revokeObjectURL(downloadUrl);
                            document.body.removeChild(a);
                        }, 800); // cleanup
                    }
                }

                //handle on complete
                if (typeof callback === 'function') {
                    callback();
                }
            };
            //handle before send
            xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
            xhr.send(JSON.stringify(formData));
        },
    },
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');

router.beforeEach((to, from, next) => {
    if (to.path !== '/') {
        if (!store.state.user.isAuthenticated) {
            axios
                .get('/api/identity')
                .then(function (resp) {
                    if (resp.data) {
                        let identity = resp.data;
                        identity.isAuthenticated = true;
                        store.commit('updateUser', identity);
                        next();
                    }
                })
                .catch(function (error) {
                    store.commit('updateUser', {isAuthenticated: false});

                    if (error.response.status === 401) {
                        window.location.href = '/identity/account/login?ReturnUrl=%2F';
                    } else if (error.response.status === 403) {
                        window.location.href =
                            '/identity/account/accessdenied?ReturnUrl=%2F';
                    }
                });
        } else {
            next();
        }
    } else {
        next();
    }
});
